<mat-dialog-content>
  <p class="font-bold text-lg mb-4">Petunjuk Pengisian</p>
  <p>1: Tidak memahami sama sekali</p>
  <p>2: Kurang Memahami (Terjadi lebih dari 7 kesalahan)</p>
  <p>3: Kurang Memahami (Terjadi 4-7 kesalahan)</p>
  <p>4: Memahami (Terjadi 2-4 kesalahan)</p>
  <p>5: Memahami (Tidak terjadi kesalahan)</p>
</mat-dialog-content>
